import { error } from '@sveltejs/kit';
import { query } from '$app/server';
import { getRequestEvent } from '$app/server';
import { loadDaily, loadCalendar } from '~/routes/db';
import { getUserPremiumStatus } from '~/lib/server/premium';
import { dateToString } from '~/utils/dates';
import { keysToCamel } from '~/utils/snakeToCamel';
import type { DateCell, DailyMode, DailyPuzzle } from '~/types';

type PuzzleParams = {
  mode?: string | null;
  date?: string | null;
  puzzle?: string | null;
};

export const getDailyPuzzle = query(
  'unchecked',
  async (params: PuzzleParams): Promise<DailyPuzzle> => {
    const { locals, cookies } = getRequestEvent();

    let userId = cookies.get('userId') ?? '';
    if (locals.user?.id) userId = locals.user.id;

    let result;

    if (params.puzzle) {
      result = await loadDaily({ userId, key: params.puzzle });
    }

    if (!result) {
      let date = params.date;
      if (!date || date === 'latest') {
        date = dateToString(new Date());
      } else if (!await getUserPremiumStatus(locals.supabase)) {
        error(401, 'not premium');
      }
      result = await loadDaily({ userId, date, mode: params.mode });
    }

    return keysToCamel(result) as unknown as DailyPuzzle;
  },
);

type CalendarParams = {
  date: string;
  mode: DailyMode;
};

export const getDailyCalendar = query(
  'unchecked',
  async (params: CalendarParams): Promise<DateCell[]> => {
    const { locals } = getRequestEvent();

    if (!locals.user) error(401, 'not signed in');

    const calendar = await loadCalendar({
      userId: locals.user.id,
      mode: params.mode,
      month: params.date,
    });

    // the RPC returns snake_case columns (full_clear)
    return keysToCamel(calendar) as unknown as DateCell[];
  },
);
